import React from 'react';
import { Button } from 'react-bootstrap';
import { ICON_CHECK } from '../../extras/icons';
//Función principal
const LawyerRow = props => {
    //Tomo los props
    const { lawyer, handleSelect } = props;
    //Renderizo
    return (
        <tr>
            <td className="align-middle">
                <strong>
                    { lawyer.apellido + ', ' + lawyer.nombre }
                    &nbsp;<small>({ lawyer.matricula.substring(1) })</small>
                </strong>
                <br/>
                <small>
                    { lawyer.oficina ? lawyer.oficina.descripcion : 'N/D' }
                    <br/>
                    CUIT: { lawyer.cuit }
                </small>
            </td>
            <td className="align-middle text-centet">
                <Button variant="warning" onClick={() => handleSelect(lawyer)}>
                    <ICON_CHECK />
                </Button>
            </td>
        </tr>
    );
};

export default LawyerRow;